// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const primeape: PokeData = {
  "id": 57,
  "name": "primeape",
  "height": 10,
  "weight": 320,
  "base_experience": 159,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "karate-chop",
    "scratch",
    "thrash",
    "leer",
    "low-kick",
    "counter",
    "seismic-toss",
    "rage",
    "screech",
    "focus-energy",
    "skull-bash",
    "fury-swipes",
    "mud-slap",
    "outrage",
    "swagger",
    "encore",
    "pursuit",
    "cross-chop",
    "taunt",
    "covet",
    "u-turn",
    "close-combat",
    "assurance",
    "fling",
    "punishment",
    "retaliate",
    "final-gambit",
    "stomping-tantrum",
    "rage-fist"
  ],
  "moves": [
    "karate-chop",
    "scratch",
    "leer",
    "seismic-toss",
    "mud-slap",
    "outrage",
    "pursuit",
    "close-combat",
    "double-kick",
    "meteor-assault",
    "jump-kick",
    "vacuum-wave",
    "drain-punch"
  ],
  "evolution_chain": {
    "id": 24,
    "item": null,
    "species": [
      {
        "name": "mankey",
        "order": 61,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "primeape",
        "order": 62,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 56,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "annihilape",
        "order": 1010,
        "types": [
          PokeType.FIGHTING,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 57,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 65,
    "speed": 95,
    "ability_power": 105
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
